import { ConfigurationV2 } from '@ketch-sdk/ketch-types'
import { useHistoricalConfig } from 'api/historicalConfig/queries/useHistoricalConfig'
import { useEffect, useState } from 'react'

type UseAuditLogHistoricalConfigParams = {
  configId: string
}

type UseAuditLogHistoricalConfigResponse = {
  config: ConfigurationV2 | null
  isLoading: boolean
}

export const useAuditLogHistoricalConfig = ({
  configId,
}: UseAuditLogHistoricalConfigParams): UseAuditLogHistoricalConfigResponse => {
  const { data: configData } = useHistoricalConfig({
    enabled: !!configId,
    params: {
      configId,
    },
    onError: () => {
      setIsLoading(false)
    },
  })

  const [config, setConfig] = useState<ConfigurationV2 | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchConfig = async () => {
      if (configData?.presignedURL) {
        const config = await fetch(configData?.presignedURL)
        const configJson = await config.json()
        if (configJson?.id) {
          setConfig(configJson)
          setIsLoading(false)
        }
      }
    }
    fetchConfig()
  }, [configData?.presignedURL])

  return { config, isLoading }
}
